import angular from 'angular';
import {KakaotalkRegisterController} from './addAccountKakaotalk.controller.js';

angular.module('parameters.addAccountKakaotalk', []).controller('KakaotalkRegisterController', KakaotalkRegisterController);
